"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _brand_1$brand_2$bran;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = (_brand_1$brand_2$bran = {
  // primary palette
  brand_1: '#513C5E',
  brand_2: '#FF005E',
  brand_3: '#0FDEBD',
  brand_4: '#273142',
  mainBackground: '#F1F4F8',
  charade: '#516173',
  // primary hover colors
  brand_1_hover: '#684E79',
  brand_2_hover: '#E60054',
  brand_3_hover: '#72E6D3',
  brand_4_hover: '#53555D',
  // support colors
  info: '#1889DF',
  info_background: '#DAEDF9',
  success: '#42B964',
  success_background: '#DDF0E6',
  warning: '#F7B500',
  warning_background: '#FEF3D0',
  danger: '#FF2C2C',
  danger_background: '#F8E7EB',
  // K1 secondary colors
  blueHaze: '#F0F0F7',
  vistaBlue: '#819FD0',
  melrose: '#A3A1FB',
  persianPink: '#FF7CC3',
  mayaBlue: '#54D8FF',
  crayolaYellow: '#FFE283',
  salmon: '#FF8474',
  lightSalmon: '#FFA177',
  shamrock: '#5EE2A0',
  // K2 secondary
  mediumPurple: '#9370DB',
  hotPink: '#FF69B4',
  cerulean: '#00BFFF',
  lemonChiffon: '#FFEC43',
  atlantis: '#9ACD32',
  copper: '#CD853F',
  steelBlue: '#4682B4',
  coral: '#FF7F50',
  teal: '#008B8B',
  bittersweet: '#FA8072',
  thunderbird: '#E63434',
  seagull: '#C32BED',
  // NEUTRALS
  // light-neutrals
  cadetBlue: '#C1C7D0',
  athensGray: '#E2E7EE',
  athensGray2: '#F1F4F8',
  white: '#FFFFFF',
  // mid-neutrals
  fiord: '#6E879F',
  raven: '#8E9BAC',
  grayChateau: '#C5D0DE',
  // dark-neutrals
  oxfordBlue: '#273142',
  riverBed: '#516173',
  lynch: '#62768B',
  // NEW COLOR NAMING SYSTEM
  purple: '#513C5E',
  purpleHover: '#684E79',
  purpleDark: '#483554',
  pink: '#FF005E',
  pinkHover: '#E60054',
  turqoise: '#0FDEBD',
  turqoiseHover: '#72E6D3'
}, _defineProperty(_brand_1$brand_2$bran, "white", '#FFFFFF'), _defineProperty(_brand_1$brand_2$bran, "background", '#F1F4F8'), _defineProperty(_brand_1$brand_2$bran, "disabled", '#E2E7EE'), _defineProperty(_brand_1$brand_2$bran, "iconLight", '#C5D0DE'), _defineProperty(_brand_1$brand_2$bran, "iconDark", '#8E9BAC'), _defineProperty(_brand_1$brand_2$bran, "mediumGray", '#7C8691'), _defineProperty(_brand_1$brand_2$bran, "typographyLight", '#516173'), _defineProperty(_brand_1$brand_2$bran, "typographyDark", '#273142'), _brand_1$brand_2$bran);

exports["default"] = _default;